


export const SlugSection = () => (
  <div className="space-y-3">
    <h3 className="text-xs font-semibold uppercase text-muted-foreground">URL Slug</h3>
    <input type="text" className="w-full border bg-background rounded px-3 py-1.5 text-sm" placeholder="my-post-slug" />
  </div>
);
